import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
import { Lead } from '../types/lead';
import { LeadWhatsAppHandoff } from './LeadWhatsAppHandoff';
export function LeadSuccess({
  lead,
  children
}: {
  lead: Lead;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border border-ok/30 bg-ok/5 p-5" role="status" data-id="element-979" data-mp="3g1uuup8zl38">
      <CheckCircle2Icon className="h-6 w-6 text-ok" aria-hidden data-id="element-980" data-mp="8elgsv3ucwvl" />
      <h3 className="mt-3 font-display text-lg font-bold" data-id="element-981" data-mp="8ed536jgfxlz">Consulta registrada</h3>
      <p className="mt-1 text-sm text-mist" data-id="element-982" data-mp="dcejvf9ularn">
        Tu número de seguimiento es <span className="font-mono font-semibold text-white" data-id="element-983" data-mp="icj3he61ylm3">{lead.code}</span>. {children}
      </p>
      <LeadWhatsAppHandoff lead={lead} data-id="element-984" data-mp="menv67cxx863" />
      <Link to={`/chequeo?code=${lead.code}#seguimiento`} className="btn btn-ghost mt-4 w-full" data-id="element-985" data-mp="mdl4o0jj57qp">
        Ver estado de mi consulta
      </Link>
    </div>;
}